import { memo } from "react";
import { PositionTableSkeletonRow } from "../row/PositionTableSkeletonRow";

export const LockedPositionSkeletonRow = memo(() => <PositionTableSkeletonRow />);

LockedPositionSkeletonRow.displayName = "LockedPositionSkeletonRow";
